// Справочные константы калькуляторов. Перенесены ДОСЛОВНО из прототипа
// партнёра (`starling-vision-prototype.jsx`, блок «Optics math helpers»):
// это данные, а не формулы, и мы их не пересматриваем.

/** Материал линзы: индекс преломления, плотность (г/см³), торговое имя. */
export interface LensMaterial {
  index: number;
  density: number;
  name: string;
}

/** Стандартный ряд диаметров заготовок, мм. */
export const STANDARD_BLANKS: readonly number[] = [55, 60, 65, 70, 75, 80];

/**
 * Материалы линз.
 *
 * NB: плотность 1.67 = 1.20 г/см³ в прототипе выглядит заниженной (у ходовых
 * MR-7/MR-10 это ~1.35). Значение оставлено как есть — это справочные данные
 * партнёра, менять их без его подтверждения нельзя (см. накопитель V1).
 */
export const MATERIALS: readonly LensMaterial[] = [
  { index: 1.5, density: 1.32, name: '1.50 (CR-39)' },
  { index: 1.56, density: 1.3, name: '1.56' },
  { index: 1.6, density: 1.3, name: '1.60' },
  { index: 1.67, density: 1.2, name: '1.67' },
  { index: 1.74, density: 1.47, name: '1.74' },
];

/** Материал по индексу; при неизвестном индексе — первый из ряда (как в прототипе). */
export function findMaterial(index: number | string): LensMaterial {
  const key = String(index);
  const found = MATERIALS.find((m) => String(m.index) === key);
  // MATERIALS непустой, но при noUncheckedIndexedAccess это надо доказать типам.
  const fallback = MATERIALS[0] as LensMaterial;
  return found ?? fallback;
}

/**
 * Опорное рабочее расстояние для аддидации, м.
 *
 * Аддидация в рецепте выписывается «для чтения», то есть для 40 см — от этой
 * точки отсчитывается поправка на другое рабочее расстояние (см. `nearPowerForDistance`).
 */
export const NEAR_REFERENCE_DISTANCE_M = 0.4;
